// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum VehicleRegisterSynchronizationStatus {
  Inapplicable = "INAPPLICABLE",
  Unprocessed = "UNPROCESSED",
  UnprocessedDueToDuplication = "UNPROCESSED_DUE_TO_DUPLICATION",
  VehicleNotFound = "VEHICLE_NOT_FOUND",
  Processed = "PROCESSED",
}
export default VehicleRegisterSynchronizationStatus;

export function vehicleRegisterSynchronizationStatusToVariant(status: VehicleRegisterSynchronizationStatus) {
  switch (status) {
    case VehicleRegisterSynchronizationStatus.Inapplicable:
    case VehicleRegisterSynchronizationStatus.VehicleNotFound:
    case VehicleRegisterSynchronizationStatus.Unprocessed:
    case VehicleRegisterSynchronizationStatus.UnprocessedDueToDuplication:
      return "danger";

    case VehicleRegisterSynchronizationStatus.Processed:
      return "success";
  }
}
